import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { Designtools } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const MarkButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isHighlight: ctx.editor.isActive('highlight') ?? false
      }
    }
  })

  const onToggleHighlight = () => {
    editor.chain().focus().toggleMark('highlight').run()
    console.log(editor.getHTML())
  }

  return (
    <Tooltip title={t('editor.highlight')}>
      <Button
        icon={<Designtools size={14} />}
        onClick={onToggleHighlight}
        type={editorState.isHighlight ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
